import { Component, Input, OnInit } from '@angular/core';

import { FieldOkViewComponent } from '../../../../data/field-ok';
import { ObjectDefinition } from '../../../../data/definitions';
import { UiCoreModule } from '@softline/ui-core';
import { DynamicTableComponent } from '../../../../components/dynamic-table/dynamic-table.component';
import {
  FilterAndSortComponent,
  FilterConfig,
  SortConfig,
} from '@softline/application';
import { WithFilterAndSort } from '../field-ok-view-filter-and-sort.mixin';
import { explore, withFilter, withSearch, withSort } from '@softline/core';
import { toSignal } from '@angular/core/rxjs-interop';

export interface FieldOkTableViewConfig {
  definition: ObjectDefinition;
  filter?: FilterConfig;
  sort?: SortConfig;
}

@Component({
  selector: 'soft-field-ok-table-view',
  imports: [
    UiCoreModule,
    FilterAndSortComponent,
    DynamicTableComponent
],
  templateUrl: './field-ok-table-view.component.html',
  styleUrls: ['./field-ok-table-view.component.css'],
})
export class FieldOkTableViewComponent
  extends WithFilterAndSort()
  implements OnInit, FieldOkViewComponent<FieldOkTableViewConfig>
{
  @Input() config!: FieldOkTableViewConfig;

  explorer = explore(toSignal(this.strategy.items$),
    withSearch(),
    withFilter(),
    withSort()
  );

  constructor() {
    super();
  }

  async ngOnInit(): Promise<void> {}
}
